import { createI18n } from 'vue-i18n';

import { loadLocaleMessages } from '@/locales/i18n';

// Import your language files
const messages = loadLocaleMessages();

// Create i18n instance
export const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'en',
    fallbackLocale: 'en',
    messages,
    warnHtmlInMessage: 'off',
    availableLocales: ['en', 'fr'],
});
